export const EnableCacheHeaderName = 'cache-enabled';
export const NoProgressIndicator = 'loading-disabled';
export const HandleTimeout = 'handle-timeout';
export const HandleTechnicalError = 'handle-technical-error';

